import { render, staticRenderFns } from "./gettrainsorsb.vue?vue&type=template&id=7de8c22b&scoped=true"
import script from "./gettrainsorsb.vue?vue&type=script&lang=js"
export * from "./gettrainsorsb.vue?vue&type=script&lang=js"
import style0 from "./gettrainsorsb.vue?vue&type=style&index=0&id=7de8c22b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de8c22b",
  null
  
)

export default component.exports